import { useEffect } from 'react';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

// Configuración de slots de AdSense - IDs reales del panel
export const ADSENSE_CONFIG = {
  client: 'ca-pub-2618827362239544',
  enabled: true, // ✅ Habilitado con slots reales de AdSense
  slots: {
    home_mobile_banner: '8944444429', // Home Mobile Banner - Real AdSense slot
    home_footer: '3623850894',        // Footer Banner - Real AdSense slot  
    game_banner: '8944444429',        // Reutilizar Home Mobile Banner para game
    lobby_sidebar: '1823684063'       // Lobby Sidebar - Real AdSense slot
  }
};

export const useAdSense = () => {
  useEffect(() => {
    // Initialize adsbygoogle array if it doesn't exist
    if (typeof window !== 'undefined' && !window.adsbygoogle) {
      window.adsbygoogle = [];
    }
  }, []);

  const loadAd = () => {
    try {
      if (window.adsbygoogle) {
        window.adsbygoogle.push({});
      }
    } catch (error) {
      console.error('Error loading AdSense ad:', error);
    }
  };

  const isAdSenseLoaded = () => {
    return typeof window !== 'undefined' && window.adsbygoogle && Array.isArray(window.adsbygoogle);
  };

  return { loadAd, isAdSenseLoaded };
};